import { render, staticRenderFns } from "./ProductSerialConfigurator.vue?vue&type=template&id=8f66abb8"
import script from "./ProductSerialConfigurator.vue?vue&type=script&lang=js"
export * from "./ProductSerialConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports